import {
  Container,
  Grid,
  Typography,
  Button,
  Box,
  CardMedia,
} from "@mui/material";
// import Header from '../Header';
import whatsAppaddsImg from "./img/whatsappAdds.png";
import CompanySection from "./CompanySection";
import WhatsAppAdd_Gateway from "./WhatsAppAdd_Gateway";
import ContentSection from "./ContentSection";
import Dashboard from "./Dashboard";
import WhatsAppSuccess from "./WhatsAppSuccess";
import FooterSection from "../FooterSection";
import Header from "../../../Header/Header";
import StatsSection from "./ContentCard";

const WhatsAppAdds = () => {
  return (
    <>
      <Header />
      <Box sx={{ backgroundColor: "#f2faf6", minHeight: "100vh" }}>
        <Container
          maxWidth="lg"
          sx={{
            py: 4,
            height: "90vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid container spacing={4} alignItems="center">
            {/* Left Section - Text and Buttons */}
            <Grid item xs={12} md={6} sx={{ order: { xs: 2, sm: 1 } }}>
              <Typography
                variant="h2"
                component="h1"
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: "2.4rem", md: "3.5rem" },
                  lineHeight: 1.1,
                }}
              >
                Drive 5X More Leads
              </Typography>
              <Typography
                variant="h2"
                component="h1"
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: "2.4rem", md: "3.5rem" },
                  color: "#00C853",
                  lineHeight: 1.1,
                }}
              >
                <span style={{ color: "black" }}>with</span> Ads that Click
              </Typography>
              <Typography
                variant="h2"
                component="h1"
                gutterBottom
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: "2.4rem", md: "3.4rem" },
                  color: "#00C853",
                  lineHeight: 1.1,
                }}
              >
                to WhatsApp
              </Typography>
              <Box mt={2}>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { xs: "1rem", md: "1.1rem" },
                    lineHeight: 1.5,
                    color: "#616060",
                  }}
                >
                  • Create impactful ads with VertexSuite that direct users to
                  WhatsApp.
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { xs: "1rem", md: "1.2rem" },
                    lineHeight: 1.5,
                    color: "#616060",
                  }}
                >
                  • Generate 5x more leads within the same budget.
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { xs: "1rem", md: "1.2rem" },
                    lineHeight: 1.5,
                    color: "#616060",
                  }}
                >
                  • Connect AI-powered chatbots.
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { xs: "1rem", md: "1.2rem" },
                    lineHeight: 1.5,
                    color: "#616060",
                  }}
                >
                  • Automate responses to boost conversions 24/7.
                </Typography>
              </Box>
              <Box mt={3} display="flex" gap={2} flexWrap="wrap">
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#00C853",
                    color: "white",
                    textTransform: "none",
                    fontSize: "1rem",
                    px: 4,
                    py: 1,
                    borderRadius: "8px",
                    "&:hover": { backgroundColor: "#00B140" },
                  }}
                  endIcon={<span>→</span>}
                >
                  Get 500 FREE Ad Credits
                </Button>
                <Button
                  variant="outlined"
                  sx={{
                    borderColor: "#00C853",
                    color: "#00C853",
                    textTransform: "none",
                    fontSize: "1rem",
                    px: 4,
                    py: 1,
                    borderRadius: "8px",
                    "&:hover": { borderColor: "#00B140", color: "#00B140" },
                  }}
                >
                  Book 1:1 Setup Call
                </Button>
              </Box>
            </Grid>

            {/* Right Section - Image Section */}
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                order: { xs: 1, sm: 2 },
              }}
            >
              <CardMedia
                component="img"
                alt="WhatsAppAdds"
                image={whatsAppaddsImg}
                sx={{
                  maxWidth: { xs: 350, md: 500 },
                  width: "100%",
                  objectFit: "contain",
                  borderRadius: "20px",
                }}
              />
            </Grid>
          </Grid>
        </Container>

        <CompanySection />
        <WhatsAppAdd_Gateway />
        <StatsSection />
        <ContentSection />
        <Dashboard />
        <WhatsAppSuccess />
        <FooterSection />
      </Box>
    </>
  );
};

export default WhatsAppAdds;
